import { useCallback, useEffect, useState } from 'react';

import { type Reviews } from '../../shared/reviews';
import { fetchProductReviewsFromUrl } from '../services';
import { useProduct } from './useProduct';

type UseReviews = {
    reviews: Reviews | null;
    areReviewsInitiallyFetched: boolean;
};

export const useReviews = (): UseReviews => {
    const { productId } = useProduct();

    const [reviews, setReviews] = useState<Reviews | null>(null);
    const [areReviewsInitiallyFetched, setAreReviewsInitiallyFetched] = useState(false);

    const fetchReviews = useCallback(async () => {
        // call to review-backend for ten reviews of the given product
        const response = await fetchProductReviewsFromUrl(productId);

        if (response && response.reviews) {
            setReviews(
                reviews
                    ? {
                          ...response,
                          reviews: [...reviews.reviews, ...response.reviews],
                      }
                    : response,
            );
        }

        setAreReviewsInitiallyFetched(true);
    }, [productId, reviews]);

    // only triggered once for initially fetching the reviews
    useEffect(() => {
        if (!reviews) {
            // eslint-disable-next-line promise/prefer-await-to-then
            fetchReviews();
        }
    }, [fetchReviews, reviews]);

    return { reviews, areReviewsInitiallyFetched };
};
